function targetsGAOnAllElements() {
  const gaAll = document.querySelectorAll('[data-ga-tracking-id]');
  gaAll.forEach((gaItem) => {
    gaItem.addEventListener('click', (e) => {
      try {
        const {
          gaTrackingId, gaType, gaCategory, gaAction,
        } = e.target.dataset;
        window.ga('create', gaTrackingId, 'auto');
        window.ga('send', gaType, gaCategory, gaAction);
      } catch (err) {
        console.error(err);
      }
    });
  });
}

function targetsGAOnForm(form) {
  try {
    const {
      gaFormTrackingId, gaFormType, gaFormCategory, gaFormAction,
    } = form.dataset;
    if (!gaFormTrackingId) return;
    window.ga('create', gaFormTrackingId, 'auto');
    window.ga('send', gaFormType, gaFormCategory, gaFormAction);
  } catch (err) {
    console.error(err);
  }
}

export { targetsGAOnAllElements, targetsGAOnForm };
